import { render, staticRenderFns } from "./ProcedureTypeAdmin.vue?vue&type=template&id=565ced37&scoped=true&lang=pug"
import script from "./ProcedureTypeAdmin.vue?vue&type=script&lang=js"
export * from "./ProcedureTypeAdmin.vue?vue&type=script&lang=js"
import style0 from "./ProcedureTypeAdmin.vue?vue&type=style&index=0&id=565ced37&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "565ced37",
  null
  
)

export default component.exports